import React from 'react';
import SectionHeader from 'commonComponents/Headers/SectionHeader/SectionHeader';
import Button from 'commonComponents/Button/Button';
import ConsultantPhotoAndName from './ConsultantPhotoAndName/ConsultantPhotoAndName';
import styles from './Consultants.module.scss';

const Consultants = ({
  consultants, header, text, button, link, type
}) => {
  const classes = `${styles.Consultants} ${ type ? styles[type] : ''}`;
  
  return ( 
    <section className={ classes }>
      <div className={ styles.content }>
        <div className={ styles.photos }>
          { consultants && consultants.map(person =>
            <ConsultantPhotoAndName { ...person } key={ person.name } />)
          }
        </div>
        <div className={ styles.info }>
          <SectionHeader title={ header } anchor='consultants' />
          <p>{ text }</p>
          <Button label={ button } link={ link } />
        </div>
      </div>
    </section>
  );
};

export default Consultants;
